/*
 * ZINDEO custom: KOUPIT NYNÍ
 * Button [data-buy-now] (type="button") inside Baseline's form[data-product-form].
 * Baseline's ProductForm intercepts every submit via AJAX and shows the "added to cart" state,
 * so this button is not a submit button. It adds the current form data (variant id, quantity,
 * properties) to the existing cart and redirects to checkout. Cart contents are kept.
 */
(() => {
  const setBusy = (button, busy) => {
    button.disabled = busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  };

  const rootUrl = () => {
    const root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    return root.endsWith('/') ? root : root + '/';
  };

  const cartAddUrl = () =>
    ((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || rootUrl() + 'cart/add') + '.js';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

    const form = button.closest('form[data-product-form]');
    if (!form) return;

    event.preventDefault();
    setBusy(button, true);

    try {
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });

      let data = null;
      try {
        data = await response.json();
      } catch (e) {
        data = null;
      }

      if (!response.ok || (data && data.status)) {
        throw new Error((data && (data.description || data.message)) || '');
      }

      window.location.assign(rootUrl() + 'checkout');
    } catch (error) {
      setBusy(button, false);
      // Reuse Baseline's error UI (Product / QuickBuy islands listen for this event).
      form.dispatchEvent(
        new CustomEvent('baseline:productform:error', {
          bubbles: true,
          detail: {
            sourceId: form.getAttribute('id'),
            message: (error && error.message) || null
          }
        })
      );
    }
  });

  // Back from checkout (bfcache): never leave the button stuck in the busy/disabled state.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-buy-now][aria-busy="true"]').forEach((button) => setBusy(button, false));
  });
})();
